/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Block } from 'particles'
export default props => <Block is='form' {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/molecules/Form/index.js